
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebase";
import "./OtherBetNavbarBottom.css";

export default function OtherBetNavbarBottom() {
  const navigate = useNavigate();

  const [antPending, setAntPending] = useState(0);
  const [correctPending, setCorrectPending] = useState(0);

  useEffect(() => {
    const unsubscribeAnt = onSnapshot(
      collection(db, "otherbetantscore"),
      (snapshot) => {
        const pending = snapshot.docs.filter(
          (d) => !d.data().result
        ).length;

        setAntPending(pending);
      },
      (error) => console.error("Against Score notification:", error)
    );

    const unsubscribeCorrect = onSnapshot(
      collection(db, "otherbetcorectscore"),
      (snapshot) => {
        const pending = snapshot.docs.filter(
          (d) => !d.data().result
        ).length;

        setCorrectPending(pending);
      },
      (error) => console.error("Correct Score notification:", error)
    );

    return () => {
      unsubscribeAnt();
      unsubscribeCorrect();
    };
  }, []);

  const totalPending = antPending + correctPending;

  return (
    <div className="navbar-bottom-notifications">
      {totalPending > 0 && (
        <div className="pending-notification">
          <span className="notification-bell">🔔</span>

          <strong>
            Pending Bets: {totalPending}
          </strong>

          {antPending > 0 && (
            <button
              type="button"
              onClick={() => navigate("/AdminOther-BetAntScore")}
            >
              Against Score ({antPending})
            </button>
          )}

          {correctPending > 0 && (
            <button
              type="button"
              onClick={() => navigate("/AdminOther-BetCorrectScore")}
            >
              Correct Score ({correctPending})
            </button>
          )}
        </div>
      )}
    </div>
  );
}
